﻿/* 
Object:         Enum Module Actions
Used in:        Breadcrumb, Session, Navigation ...
*/

window.ModuleActionViewEnum = {};

Object.defineProperties(window.ModuleActionViewEnum, {
    Overview: { value: 0, writable: false },
    Show: { value: 1, writable: false },
    Add: { value: 2, writable: false },
    Edit: { value: 3, writable: false }
});

Object.freeze(window.ModuleActionViewEnum);